import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonTypeEnum } from '../../../../../../ui/buttons/button/button-type.enum';

@Component({
  selector: 'app-vb-payments-next-payment-by',
  templateUrl: './vb-payments-next-payment-by.component.html',
  styleUrls: ['./vb-payments-next-payment-by.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsNextPaymentByComponent {
  @Input({ required: true }) nextPaymentDate!: string;
  @Output() viewUpcomingPayments = new EventEmitter<void>();
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
